export const RESET = 'ROLE_LIST_RESET'
export const SET_ITEMS = 'ROLE_LIST_SET_ITEMS'
export const SET_ERROR = 'ROLE_LIST_SET_ERROR'
export const SET_VIEW = 'ROLE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'ROLE_LIST_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/role/list/mutation_types.js